import { render, staticRenderFns } from "./app.html?vue&type=template&id=6b4780d8&scoped=true&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"
import style0 from "./app.css?vue&type=style&index=0&id=6b4780d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4780d8",
  null
  
)

export default component.exports